import { faClock, faDiagramProject, faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DateStartEndForList from '../task/DateStartEndForList';
import { useSelector } from 'react-redux';
import PercentSuccessV2 from '../ui/PercentSuccessV2';
import { useEffect, useState } from 'react';
import UserList from './UserList';
import CardTimetable from '../../Pages/Lk/TaskR/Setting/CardTimetable';
import ScrollContainer from 'react-indiana-drag-scroll';

function TaskItem({ idObject, item, listLabel, listCheckList, listUser, listTimetable, editHandler
    , showUser, showPercent, showCheckList, showDateStartEnd, showTimetable
}) {

    const stateSize = useSelector((state) => state.size);
    const stateUserList = useSelector((state) => state.userList);//Пользователи

    const [users, setUsers] = useState([]);

    useEffect(() => {
        if (showUser === true) {
            const users_ = listUser.map(item => {
                if (stateUserList.list.filter(a => a.ID_User === item.ID_User).length > 0) {
                    return {
                        ...item
                        , User_Name: stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Name_User
                        , Avatar: stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Avatar_Small
                    };
                }
                else {
                    return { ...item, User_Name: 'Не найден...' };
                }
            })

            setUsers(users_)
        }

    }, [listUser, stateUserList.list]);

    return (
        <>
            {stateSize.desktop === true ? (
                <div key={item.ID + '_' + item.ID_User} className={"list_item mt-15 priority_border_color_" + item.Priority} onClick={() => { editHandler(item) }}>
                    <div style={{ width: '50%' }}>
                        <div>
                            <div className='title' >{item.Name}{item.Viewed === false && <span className="badge badge-menu warning badge-dot ml-5"> </span>}</div>
                            <div className='subtitle'>{item.ID_Project !== null ? <div><FontAwesomeIcon icon={faDiagramProject} className="mr-5" />{item.Name_Project}</div> : <div className="text-danger">проект не выбран</div>}</div>
                            {
                                listLabel.map((label) => (
                                    <div key={item.ID_TaskR + '_' + label.ID_Label} className="mr-2 badge_item" style={{ backgroundColor: label.Color, color: "white" }} >
                                        {label.Name}
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    {showUser === true && (
                        <div className="center" style={{ width: '300px' }}>
                            <UserList list={users} id_type={item.ID_Type} />
                        </div>
                    )}
                    {showCheckList === true && (
                        <div className="center" style={{ width: '70px' }}>
                            {listCheckList.length > 0 &&
                                <>
                                    {idObject === 1 &&
                                        (
                                            <div>
                                                <FontAwesomeIcon icon={faSquareCheck} className="mr-5" />
                                                <b>{listCheckList.filter(a => a.ID_Item === item.ID & a.Completed == true).length}</b>
                                                /
                                                <b>{listCheckList.filter(a => a.ID_Item === item.ID).length}</b>
                                            </div>
                                        )}
                                    {idObject === 6 &&
                                        (
                                            <div>
                                                <FontAwesomeIcon icon={faSquareCheck} className="mr-5" />
                                                <b>{listCheckList.filter(a => a.ID_TaskR_Tracker === item.ID & a.Completed == true).length}</b>
                                                /
                                                <b>{listCheckList.filter(a => a.ID_TaskR_Tracker === item.ID).length}</b>
                                            </div>
                                        )}
                                </>
                            }
                        </div>
                    )}
                    {showDateStartEnd === true && (
                        <div className="end" style={{ width: '250px' }}>
                            {idObject === 1 ?
                                (
                                    <small><DateStartEndForList date_start={item.Date_Start} date_end={item.Date_End} /></small>
                                )
                                :
                                (
                                    <div>
                                        <div><i className="mr-5"><FontAwesomeIcon icon={faClock} /></i>{item.Timetable_String === null ? "Вручную" : item.Timetable_String}</div>
                                        <small><DateStartEndForList date_start={item.Date} date_end={item.Date_Finish} date_completed={item.Completed_Date} /></small>
                                    </div>
                                )
                            }
                        </div>
                    )}
                    {showPercent === true && (
                        <div className="end" style={{ width: '50px' }}>
                            <div style={{ display: "inline-block" }}>
                                {item.ID_Type === 2 &&
                                    <PercentSuccessV2 percent={Math.round(100 / item.User_All * item.User_Completed)} countAll={item.User_All} countComplete={item.User_Completed} />
                                }
                            </div>
                        </div>
                    )
                    }
                    {showTimetable === true && (
                        <div className="end" style={{ width: "280px" }}>
                            <div>
                                {listTimetable.length === 0 ? (
                                    <div className='form_error'>Нет расписания</div>
                                ) :
                                    (
                                        listTimetable.filter(a => a.ID_TaskR === item.ID).map((timetable) => (
                                            <div key={timetable.ID}>
                                                <div><i className="mr-5"><FontAwesomeIcon icon={faClock} /></i>{timetable.Timetable_String} {timetable.Day_Complite !== null && (
                                                    <small className="widget-subheading"><i>({timetable.Day_Complite} дн.</i>)</small>
                                                )}</div>
                                            </div>
                                        ))
                                    )
                                }
                            </div>
                        </div>
                    )}
                </div>
            ) : (
                <div key={item.ID + '_' + item.ID_User} className={"m_list_item mt-15 priority_border_color_" + item.Priority} onClick={() => { editHandler(item) }}>
                    <div>
                        <div className='title' >{item.Name}{item.Viewed === false && <span className="badge badge-menu warning badge-dot ml-5"> </span>}</div>
                        <div className='subtitle'>{item.ID_Project !== null ? <div><FontAwesomeIcon icon={faDiagramProject} className="mr-5" />{item.Name_Project}</div> : <div className="text-danger">проект не выбран</div>}</div>

                        <div className="badge_block" >
                            <ScrollContainer className="scroll-container">
                                {listLabel.map((label) => (
                                    <div key={item.ID_TaskR + '_' + label.ID_Label} className="badge_item" style={{ backgroundColor: label.Color }} >
                                        {label.Name}
                                    </div>
                                ))}
                            </ScrollContainer>
                        </div>
                    </div>
                    {showDateStartEnd === true && (
                        <div style={{ fontSize: '12px' }} className='mt-5'>
                            {idObject === 1 ?
                                (
                                    <small><DateStartEndForList date_start={item.Date_Start} date_end={item.Date_End} /></small>
                                )
                                :
                                (
                                    <div>
                                        <div><i style={{ marginRight: '8px' }}><FontAwesomeIcon icon={faClock} /></i>{item.Timetable_String === null ? "Вручную" : item.Timetable_String}</div>
                                        <div><DateStartEndForList date_start={item.Date} date_end={item.Date_Finish} date_completed={item.Completed_Date} /></div>
                                    </div>
                                )
                            }
                        </div>
                    )}
                    {showCheckList === true && (
                        <div className='mt-5'>
                            {listCheckList.filter(a => a.ID_TaskR_Tracker === item.ID).length > 0 &&
                                <>
                                    {idObject === 1 &&
                                        (
                                            <div>
                                                <FontAwesomeIcon icon={faSquareCheck} className="mr-5" />
                                                <b>{listCheckList.filter(a => a.ID_Item === item.ID & a.Completed == true).length}</b>
                                                /
                                                <b>{listCheckList.filter(a => a.ID_Item === item.ID).length}</b>
                                            </div>
                                        )}
                                    {idObject === 6 &&
                                        (
                                            <div>
                                                <FontAwesomeIcon icon={faSquareCheck} className="mr-5" />
                                                <b>{listCheckList.filter(a => a.ID_TaskR_Tracker === item.ID & a.Completed == true).length}</b>
                                                /
                                                <b>{listCheckList.filter(a => a.ID_TaskR_Tracker === item.ID).length}</b>
                                            </div>
                                        )}
                                </>
                            }
                        </div>
                    )}
                    {showUser === true && (
                        <div className="mt-5">
                            <UserList list={users} id_type={item.ID_Type} />
                        </div>
                    )}
                    {showPercent === true && (
                        <div className="mt-5">
                            {
                                item.ID_Type === 2 &&
                                <PercentSuccessV2 percent={Math.round(100 / item.User_All * item.User_Completed)} />
                            }
                        </div>
                    )
                    }
                    {showTimetable === true && (
                        <div className="mt-10">
                            <CardTimetable idTask={item.ID} onlyRead={true} />
                        </div>
                    )}
                </div>
            )}
        </>)
}

export default TaskItem;